import { getSessionFormattedSchedule } from '@airreading/common';
import clsx from 'clsx';
import { CalendarClock } from 'lucide-react';
import { Temporal } from 'temporal-polyfill';

interface SessionScheduleCellProps {
  startInstant: Temporal.Instant;
  endInstant: Temporal.Instant;
  displayTimeZone: string;
  showIcon?: boolean;
  showWeekday?: boolean;
  className?: string;
  'data-testid'?: string;
}

export const SessionScheduleCell = ({
  startInstant,
  endInstant,
  displayTimeZone,
  showIcon = false,
  showWeekday = false,
  className = '',
  'data-testid': dataTestId,
}: SessionScheduleCellProps) => {
  const { sessionTimeFormatted } = getSessionFormattedSchedule({
    startInstant,
    endInstant,
    displayTimeZone,
  });

  const zonedDateTime = startInstant.toZonedDateTimeISO(displayTimeZone);
  const date = zonedDateTime.toPlainDate();

  const monthDayFormatted = `${date.toLocaleString('en-US', { month: 'short' })} ${date.day}`;

  return (
    <div className={clsx('flex gap-2', className)} data-testid={dataTestId}>
      {showIcon && <CalendarClock className="w-5" />}
      {showWeekday && `${date.toLocaleString('en-US', { weekday: 'short' })}, `}
      {monthDayFormatted}, {sessionTimeFormatted}
    </div>
  );
};
